export default [
  {
    path: "/backoffice/payments/vouchers",
    name: "VouchersList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Payments" },
        { label: "Vouchers List" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "payments" */ "@/views/backoffice/Payments/VouchersList.vue"
      ),
  },
  {
    path: "/backoffice/payments/vouchers/create",
    name: "VoucherCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Payments" },
        { label: "Vouchers List", to: "/backoffice/payments/vouchers" },
        { label: "Voucher Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "payments" */ "@/views/backoffice/Payments/VoucherCreate.vue"
      ),
  },
  {
    path: "/backoffice/mpesa",
    name: "MpesaDashboard",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Payments" },
        { label: "MPesa" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "payments" */ "@/views/backoffice/Payments/MpesaDashboard.vue"
      ),
  },
];
